// var pathname = window.location.pathname;
// var langCode= pathname.split("/");
// var link = document.querySelector(".header__lang"),
//     langFormatted = (langCode[1] == 'en') ? 'EN' : 'FR',
//     linkHref = '';
// if (langCode[1] == 'en') {
//   linkHref = 'https://eleganza.ca/' + langCode.slice(2,langCode.length).join('/') + window.location.search;
//   link.innerText = 'FR';
// } else {
//   linkHref = 'https://eleganza.ca/en' + langCode.join('/') + window.location.search;
//   link.innerText = 'EN';
// }
// link.onclick = (e) => {
//   e.preventDefault();
//   window.open(linkHref,"_self");
// }

function showChat() {
  FB.CustomerChat.show();
  FB.CustomerChat.showDialog();
}
function qs (selector, searchIn) {
  return searchIn ? searchIn.querySelector(selector) : document.querySelector(selector)
}
function qsa (selector, searchIn) {
  return searchIn ? searchIn.querySelectorAll(selector) : document.querySelectorAll(selector)
}

function qsaEach (selector, searchIn, func) {
  let arr = searchIn ? searchIn.querySelectorAll(selector) : document.querySelectorAll(selector);
  [...arr].forEach(func)
}  

document.addEventListener("DOMContentLoaded", function() {

  qs('.header__cart').onclick = () => {
    if(!qs('.header__cart').classList.contains('cart-templ')) {
      qs('.cart-fixed').classList.add('active');
      qs('#shopify-section-header').classList.add('topmost-layer');
    }
  }
  window.onclick = (e) => {
    if(qs('.cart-fixed') && qs('.cart-fixed').classList.contains('active') &&
       !e.target.closest('.cart-fixed-wrap') &&
       !e.target.closest('.header__cart') ||
       e.target.closest('.cart-close')) {
      qs('.cart-fixed').classList.remove('active');
      qs('#shopify-section-header').classList.remove('topmost-layer');

    }

    if(qs('.mobile-filter') && !e.target.closest('.boost-pfs-filter-tree') && !e.target.closest('.mobile-filter')) {
      qs('.collection-content .grid__item--sidebar').classList.remove('active');
    }

    if(qs('.header__bottom').classList.contains('active') && !e.target.closest('.header__bottom-wrap') && !e.target.closest('.header__hamb')) {
      qs('.header__bottom').classList.remove('active');
      qs('#shopify-section-header').classList.remove('topmost-layer');
    }

    if(e.target.closest('.boost-pfs-search-btn-clear-suggestion')) {
      e.target.closest('form').querySelector('input').value = '';
      var inp = new Event('input');
      e.target.closest('form').querySelector('input').dispatchEvent(inp); 
    }

    if(e.target.closest('.boost-pfs-search-suggestion-group a[href*=search]')) {
      e.preventDefault();

      let search_input =  qs('#boost-pfs-search-box-style3') || qs('#boost-pfs-search-box-mobile'),
          search_term = e.target.closest('.boost-pfs-search-suggestion-group a[href*=search]').innerText;
      search_input.value = search_term;

      var inp = new Event('input');
      search_input.dispatchEvent(inp); 

      const end = search_input.value.length;

      search_input.setSelectionRange(end, end);

      var focus = new Event('click');
      search_input.dispatchEvent(focus); 

      search_input.focus();
    }

    if(e.target.closest('.boost-pfs-search-btn-close-suggestion')) {
      let panel = qs('.boost-pfs-search-suggestion-style3-top-panel') || qs('.boost-pfs-search-suggestion-mobile-top-panel'),
          results = qs('#boost-pfs-search-suggestion-style3') || qs('#boost-pfs-search-suggestion-mobile');

      panel.classList.remove('active');
      results.classList.remove('active');

      document.scrollingElement.style.height = 'auto';
      document.scrollingElement.style.position = 'initial';
      document.scrollingElement.style.overflow = 'initial';
    }

    if((e.target.closest('.boost-pfs-search-suggestion-style3-top-panel.active') || e.target.closest('.boost-pfs-search-suggestion-mobile-top-panel.active')) && !e.target.closest('[class*="top-panel"] form')) {
      qs('.boost-pfs-search-btn-close-suggestion').click();
    }

  }

  let hamb = qs('.header__hamb'),
      menu = qs('.header__bottom'),
      close = qs('.header__close'),
      back = qs('.header__back');

  hamb.onclick = () => {
    menu.classList.add('active');
    qs('#shopify-section-header').classList.add('topmost-layer');
  }
  close.onclick = () => {
    menu.classList.remove('active');
    qs('#shopify-section-header').classList.remove('topmost-layer');
  }


  qsa('.header__link').forEach(el => {
    el.onclick = (e) => {
      if(window.innerWidth < 1024 && el.classList.contains('meganav-enabled')) {
        e.preventDefault();
        el.nextElementSibling.classList.add('active');
        back.classList.add('active');
      }
    }
  })

  back.onclick = (e) => {
    qs('.header__meganav.active').classList.remove('active');
    back.classList.remove('active');
  }

  let subnavs = qsa('.header__sub-link, .collapsible-trigger');

  subnavs.forEach(el => {
    el.onclick = (e) => {
      // if(window.innerWidth < 1024) {
        let answer = el.nextElementSibling;
        if(el.classList.contains('active')) {
          el.classList.remove('active');
          answer.style.height = '0px';
        } else {
          el.classList.add('active');
          answer.style.height = answer.scrollHeight + 'px';
        }
      // }
    };
  })

  qsaEach('.all-brands-btn', 0, (el) => {
    el.onclick = () => {
      localStorage.setItem('show-all-brands', 'true');  
    }
  })

  qs('.header__search input').onfocus = () => {
    showSearch();
  }

  qs('.header__search-btn').onclick = () => {
    var ev = new Event('focusin');
    qs('.header__search input').dispatchEvent(ev);
    showSearch();
  }


  function showSearch () {
    document.scrollingElement.scrollTop = 0;

    document.scrollingElement.style.height = window.innerHeight + 'px';
    document.scrollingElement.style.position = 'fixed';
    document.scrollingElement.style.overflow = 'hidden';

    let panel = qs('.boost-pfs-search-suggestion-style3-top-panel') || qs('.boost-pfs-search-suggestion-mobile-top-panel'),
        results = qs('#boost-pfs-search-suggestion-style3') || qs('#boost-pfs-search-suggestion-mobile');
let rectSearch = qs('.header__search').getBoundingClientRect();
    let panelTop = qs('.toolbar-section').clientHeight + qs('.header__top-bar').clientHeight,
form = panel.querySelector('form');

    panel.querySelector('form[action]').setAttribute('action', qs('.header__search form').getAttribute('action'));

    panel.classList.add('active');
    panel.style.top = '0px';
panel.style.height = panelTop + 'px';
form.style.left = rectSearch.left  + 'px';
    form.style.height = rectSearch.height  + 'px';
    form.style.width = rectSearch.width  + 'px';
    form.style.top = rectSearch.top  + 'px';
    form.style.position = 'absolute';
    
    results.style.setProperty("--top", panelTop + 'px');
    results.style.height = `calc(100% - ${panelTop}px)`;
    results.classList.add('active');
  }
});